__turbopack_context__.v({
  "animating": "BookPrompt-module__zSEpzW__animating",
  "bookDetailsOpen": "BookPrompt-module__zSEpzW__bookDetailsOpen",
  "container": "BookPrompt-module__zSEpzW__container",
  "feedbackWrapper": "BookPrompt-module__zSEpzW__feedbackWrapper",
  "icon": "BookPrompt-module__zSEpzW__icon",
  "prompt": "BookPrompt-module__zSEpzW__prompt",
  "text": "BookPrompt-module__zSEpzW__text",
});
